import ReactGA from 'react-ga';
import { GATrackConstant } from '../constants/CommonConstants';
import { UserRoleType } from '../constants/JobBoardConstants';

export default class GAHelper {
    public static initialize = (trackingId: string, isDebug = false) => { 
        ReactGA.initialize(trackingId, {
            debug: isDebug
        });
    }

    public static pageView = (suffix = '') => {
        const type = suffix === '' ? suffix : ` (${suffix})`;
        ReactGA.pageview(window.location.pathname + window.location.search + type);
    }

    public static event = (category: string, action: string, label = '') => {
        ReactGA.event({category, action, label});
    }

    public static eventWithRole = (role: string | undefined, action: string, label = '') => {
        let category = '';
        let checkRole = role || '';
        if (checkRole === UserRoleType.BUYER) {
            if(window.location.pathname.match('/job-board/list')){
                category = GATrackConstant.BuyerSearchJobBoard;
            }
            if(window.location.pathname.match('/job-board/detail')){
                category = GATrackConstant.BuyerViewJobBoard;
            }
        } else if (checkRole === UserRoleType.SUPPLIER) {
            if(window.location.pathname.match('/job-board/list')) {
                category = GATrackConstant.SupplierSearchJobBoard;
            }
            if(window.location.pathname.match('/job-board/detail')) {
                category = GATrackConstant.SupplierViewJobBoard;
            }
        }
        ReactGA.event({category, action, label});
    }

}